module.exports = {
  schema: {
    name: '價格表',
    type: 'Object',
    contents: {
      name: {
        type: 'String',
        name: '價格表名稱',
      },
      // spec: {
      //   type: 'Object',
      //   name: '規格',
      // },
      // stock: {
      //   type: 'Array',
      //   name: '庫存',
      //   contents: [{
      //     type: 'ObjectId',
      //     reference: 'stocks',
      //     refKeys: ['id'],
      //   }],
      // },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'name', width: 100 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '價格表',
          rows: [
            [{ key: 'name' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/pricebooks.js